export default function BasicModal({ visible, onClose }) {
  const handleOnClose = (e) => {
    if (e.target.id === "modal_container") onClose();
  };
  if (!visible) return null;
  return (
    <div
      id="modal_container"
      onClick={handleOnClose}
      className="fixed inset-0 bg-black bg-opacity-10 backdrop-blur-sm flex justify-center items-center"
    >
      <div className="bg-white mx-4 w-fit sm:w-[420px]  lg:w-[680px] ">
        <div className="flex justify-between items-center pb-4 sm:pb-6 border-b border-gray-200 p-4 sm:p-6">
          <p className="text-gray-900 font-semibold text-lg ">Contact Us</p>
          <button onClick={onClose}>
            <img src="/images/VLSI/modal/modal_cross_icon.svg" />
          </button>
        </div>
        <div className="p-4 sm:p-6 flex gap-5 sm:gap-10 lg:gap-20">
          <div className=" flex flex-col text-gray-500">
            <span className="font-bold">Visit our office:</span>
            <span>SILVER LAKE, United States </span>
            <span className="font-normal">1941 Late Avenue</span>
            <span className="font-normal text-gray-900">
              Zip Code/Postal <span className="text-gray-500">code: 03875</span>
            </span>
          </div>
          <div className=" flex flex-col text-gray-500">
            <span>Give us a call:</span>
            <span>+8801717777777</span>
            <span>+8801917777777</span>
          </div>
        </div>
      </div>
    </div>
  );
}
